import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import AboutHeader from '../components/AboutHeader';
import OurCommitment from '../components/OurCommitment';
import FaqSection from '../components/FaqSection';
import './FullAboutPage.css';

const FullAboutPage = () => {
    // Scroll to top when the page loads
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="full-about-page">
            <Navbar />

            <main className="about-page-content">
                <AboutHeader />
                <OurCommitment />
                <FaqSection />
            </main>

            <Footer />
        </div>
    );
};

export default FullAboutPage;
